export const getTitle = (title) => {
    return title ? `${title} - Waterproof Jack` : "Waterproof Jack";
}
